module.exports = __webpack_public_path__ + "zgw-mod.jpg?ae30ed1624b6d026e17784c4a7186114";